/* ============================================
   Custom B2B Categories slider — behaviour
   ============================================ */
(function () {
  function initSlider(root) {
    if (!root || root.__b2bCatInit) return;
    root.__b2bCatInit = true;

    var track = root.querySelector('[data-track]');
    var prev = root.querySelector('[data-dir="prev"]');
    var next = root.querySelector('[data-dir="next"]');
    if (!track) return;

    function cardStep() {
      var card = track.querySelector('.custom-b2b-categories__card');
      if (!card) return track.clientWidth;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '20') || 20;
      return card.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function update() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll() - 2;
    }

    /* Scroll by ~one page (visible cards minus one), instant.
       Note: animated/smooth scrolling is intentionally avoided — the Ella
       theme resets scrollLeft on the rapid scroll events that smooth
       scrolling fires, so a single instant jump is the reliable approach. */
    function page(dir) {
      var step = cardStep();
      var visible = Math.max(1, Math.round(track.clientWidth / step));
      var delta = dir * step * Math.max(1, visible - 1);
      var target = Math.max(0, Math.min(track.scrollLeft + delta, maxScroll()));
      track.scrollLeft = target;
      update();
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    update();
    setTimeout(update, 400);
    setTimeout(update, 1200);
    var imgs = track.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete) imgs[i].addEventListener('load', update, { once: true });
    }
  }

  function initAll(ctx) {
    var scope = ctx || document;
    var sliders = scope.querySelectorAll('[data-b2b-categories]');
    for (var i = 0; i < sliders.length; i++) initSlider(sliders[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Shopify theme editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
